<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader  :selected_page="page_yw"></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->
		<div class="ro-home-content">
			<div class="ro-home-content-box">
				<div style="width: 1100px;background-color: white;padding:50px;margin: auto;box-shadow:0px 0px 20px #8a8a8a;">
					<!-- <img src="../static/picture/sf_test.png" style="width: 75%;"/> -->
					<div style="overflow: hidden;">
						<div class="section-title" style="padding:20px 0;background-color: white;margin-bottom: 0;">
							<h3>我们的业务</h3>
							<span class="h3 text-theme sec-subtitle" style="margin-top: -20px;">Business
								Introduction</span>
						</div>
						<div class="row vs-carousel wow fadeIn" data-wow-delay="0.3s" data-slide-show="3"
							style="padding:20px;background-color: white;">
							<div class="col-xl-4 mb-25" @click="clickMenu" data-type="kjcx">
								<div class="service-box">
									<div class="sr-content">
										<h3 class="h4">
											<a class="text-reset">科技查新</a>
										</h3>
										<p class="fs-xs ro-content-overflow-3">
											{{cscy_description}}
											</p>
									</div><!-- <a href="#/user/kjcx" class="icon-btn style4"><i	class="far fa-long-arrow-alt-right"></i></a> -->
								</div>
							</div>
							<div class="col-xl-4 mb-25" @click="clickMenu" data-type="kjcy">
								<div class="service-box">
									<div class="sr-content">
										<h3 class="h4">
											<a class="text-reset">科技查引</a>
										</h3>
										<p class="fs-xs ro-content-overflow-3">
											{{kjcy_description}}</p>
									</div><!-- <a href="#/user/kjcy" class="icon-btn style4"><i	class="far fa-long-arrow-alt-right"></i></a>  -->		
								</div>
							</div>
						
							<div class="col-xl-4 mb-25" @click="clickMenu" data-type="scics">
								<div class="service-box">
									<div class="sr-content">
										<h3 class="h4">
											<a class="text-reset">SCI查收</a>
										</h3>
										<p class="fs-xs ro-content-overflow-3">
											{{sci_description}}
											</p>
									</div><!-- <a href="#/user/SCI" class="icon-btn style4"><i class="far fa-long-arrow-alt-right"></i></a> -->
								</div>
							</div>
						</div>
						<div style="text-align: left;padding:20px;" v-if="mytype == 'kjcy'">
							<div style="box-shadow:0px 0px 20px #8a8a8a;padding:20px;">
								<h4 style="text-align: center;">查收查引</h4>
								<div v-html=" kjcx_description_detail"/>
							</div>
						</div>
						
						<div style="text-align: left;padding:20px;" v-if="mytype == 'kjcx'">
							<!-- <div style="box-shadow:0px 0px 20px #8a8a8a;padding:20px;"> -->
							<div style="box-shadow:0px 0px 20px #8a8a8a;padding:20px;">
								<h4 style="text-align: center;">科技查新</h4>
								<div v-html="cscy_description_detail"/>
							</div>
						
						</div>
					
						<div style="text-align: left;padding:20px;" v-if="mytype == 'scics'">
							<div style="box-shadow:0px 0px 20px #8a8a8a;padding:20px;">
								<h4 style="text-align: center;">SCI查收</h4>
								<div v-html="sci_description_detail"/>
							</div>
						</div>
				
				<div class="section-title" style="padding:20px 0;background-color: white;margin-top: 50px;text-align: center;">
					<h3>业务流程</h3>
					<span class="h3 text-theme sec-subtitle" style="margin-top: -20px;">
						operation flow</span>
				</div>
				<img :src="intro_img"/>
					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";

	import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
	export default {
		name: "App",
		data() {
			return {
				page_yw:'业务介绍',
				mytype: 'kjcx',
				intro_img: '',
				sci_description:'',
				kjcy_description:'',
				cscy_description:'',
				sci_description_detail:'',
				kjcy_description_detail:'',
				kjcx_description_detail:'',
				cscy_description:'',
				// kjcx: [
				// 	{
				// 		title: '一、小标题1',
				// 		content: [{
				// 			text: '1、内容1'
				// 		}, {
				// 			text: '2、内容2'
				// 		}, {
				// 			text: '3、内容3'
				// 		}, {
				// 			text: '4、内容4'
				// 		}],
				// 	},
				// 	{
				// 		title: '二、小标题2',
				// 		content: [{
				// 			text: '1、内容1'
				// 		}, {
				// 			text: '2、内容2'
				// 		}, {
				// 			text: '3、内容3'
				// 		}, {
				// 			text: '4、内容4'
				// 		}],
				// 	},
				// 	{
				// 		title: '三、小标题3',
				// 		content: [{
				// 			text: '1、内容1'
				// 		}, {
				// 			text: '2、内容2'
				// 		}, {
				// 			text: '3、内容3'
				// 		}, {
				// 			text: '4、内容4'
				// 		}],
				// 	},
				// ],




			}
		},
		mounted() {
			this.get_home_setting()
		},
		methods: {
			clickMenu(e) {
				let mytype = e.currentTarget.dataset.type
				console.log(mytype)
				this.mytype = mytype
			},
			get_home_setting() {
				var self = this
				fetchPost('/ro/tec_search/settings/website/v1').then(response => {
					console.log(response.data)
					self.cscy_description = response.data.list.intro_tech
					self.cscy_description_detail = response.data.list.intro_tech_detail
					self.cscy_url = response.data.list.reference_img
					self.intro_img = response.data.list.intro_img
			
					self.kjcy_description = response.data.list.intro_reference
					self.kjcx_description_detail = response.data.list.intro_reference_detail
					self.kjcy_url = response.data.list.reference_img
			
					self.sci_description = response.data.list.intro_sci
					self.sci_description_detail = response.data.list.intro_sci_detail
					self.sci_url = response.data.list.sci_img
					self.notice = response.data.list.notice_list
					if( response.data.list.notice_list.length>3){
						self.show_find_more =true
					}
					console.log(self.notice)
				})
			}
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			testprops,
		},
	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content {
		width: 100%;
		background: #F0F0F0;
		overflow: hidden;
		padding: 20px 0;
		background-image: url(../assets/img/bg/bg-7.jpg);
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: cover;
	}

	.ro-home-content-box {
		width: 1140px;
		margin: auto;
		padding: 40px 0;
	}
	.ro-content-overflow-3{
		width: 100%;
		height:72px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp:3;
	}
</style>
